export default __webpack_public_path__ + "static/media/23.2ff73861.wav";